import { ScrollToMode, LoadMoreListHandle } from '../components/LoadMoreList';
import * as React from 'react';

let listRefs: { [key: string]: React.RefObject<LoadMoreListHandle> } = {};

export function scroll(id: string, index: number, scrollToMode: ScrollToMode) {
    const ref = listRefs[id];
    if (ref?.current) {
        ref.current.scroll(index, scrollToMode);
    }
}

export function registerListRef(id: string, ref: React.RefObject<LoadMoreListHandle>) {
    if (!listRefs[id] && ref) {
        listRefs[id] = ref;
    }
}

export function removeListRef(id: string) {
    listRefs[id] = null;
}
